/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CHECK_PAYMENT_FROM_FAC } from "../graphql/checkoutFAC.mutation";
import { VApplication } from "../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface CreatePayFACProps {
  amount: number;
  currency?: string;
  notes?: string;
  payOrder?: boolean;
  mode?: string;
}
export interface ICreatePayFACMethods extends IPluginMethodMap {
  createPayFAC(args: any): Promise<any>;
}

export class CreatePayFACService implements IAgentPlugin {
  readonly methods: ICreatePayFACMethods;

  constructor() {
    this.methods = {
      createPayFAC: this.createPayFAC.bind(this),
    };
  }

  async createPayFAC(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    if (args?.payOrder?.id === null || args?.payOrder?.id === undefined) {
      throw Error("Pay order cannot be null or empty");
    }

    try {
      if (client) {
        const dateStr = args?.event?.doe;
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const yyMM = (year % 100).toString().padStart(2, '0') + month.toString().padStart(2, '0');
        const res = await client.mutate({
          mutation: CHECK_PAYMENT_FROM_FAC,
          variables:
          {
            data: {
              cardDetail: {
                cardExp: yyMM,
                cardHolderName: args?.event?.holderName,
                cardPan: args?.event?.cardPan,
                cvv: args?.event?.cvv
              },
              currency: args?.event?.currency,
              // tax: uuidv4(),
              totalAmount: parseFloat(args?.event?.amount),
              payOrder: args?.payOrder?.id,
            }
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
